import React from "react";
import { motion } from "framer-motion";

interface PhishingReportButtonProps {
  text: string;
  onClick: () => void;
  disabled?: boolean;
  icon?: React.ReactNode;
  className?: string;
  align?: "start" | "center";
  variant?: "default" | "emphasis";
}

export function PhishingReportButton({
  text,
  onClick,
  disabled = false,
  icon,
  className = "",
  align = "center",
  variant = "default",
}: PhishingReportButtonProps) {
  const isEmphasis = variant === "emphasis";
  const isStart = !isEmphasis && align === "start";
  const glass = isEmphasis ? "glass-border-1 phishing-report-emphasis" : "glass-border-4";
  return (
    <div className={`relative ${isEmphasis ? "w-full " : ""}${className}`}>
      <motion.button
        whileHover={!disabled && !isEmphasis ? { scale: 1.05 } : (!disabled && isEmphasis ? { y: -1 } : undefined)}
        whileTap={!disabled ? (isEmphasis ? { scale: 0.98 } : { scale: 0.95 }) : undefined}
        onClick={(e) => { if (!disabled) onClick?.(); e.currentTarget.blur(); }}
        disabled={disabled}
        aria-disabled={disabled}
        data-variant={variant}
        className={`group relative ${isEmphasis ? "flex" : "inline-flex"} items-center ${isStart ? "justify-start" : "justify-center"} space-x-2 ${isEmphasis ? "px-5 h-12 font-semibold" : "px-4 h-10"} ${glass} transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 focus-visible:ring-offset-2 focus-visible:ring-offset-transparent overflow-hidden text-[#1C1C1E] dark:text-[#F2F2F7] w-full ${disabled ? "opacity-60 pointer-events-none" : ""}`}
      >
        {isEmphasis ? (
          <>
            <div className="corner-top-left pointer-events-none" />
            <div className="corner-bottom-right pointer-events-none" />
          </>
        ) : null}
        <motion.div
          className={`absolute inset-0 ${isEmphasis ? "bg-gradient-to-r from-transparent via-white/35 to-transparent" : "bg-gradient-to-r from-transparent via-white/20 to-transparent"}`}
          animate={disabled ? undefined : { x: ["-100%", "200%"] }}
          transition={{
            duration: isEmphasis ? 2.6 : 2,
            repeat: Infinity,
            ease: "linear",
          }}
        />
        <span className="relative z-10 flex items-center">
          {icon}
        </span>
        <span className={`relative z-10 ${isEmphasis ? "font-semibold" : "font-medium"}`}>{text}</span>
      </motion.button>
    </div>
  );
}
